import React, { useEffect, useState } from 'react';
import cssClasses from './row.css';
import Cell from './Cell/Cell';
import { ContextMenuTrigger } from "react-contextmenu";
import { areEqual } from "react-window";

const collect = (props) => {
    return props;
}

const Row = (props) => {
    // console.log(`Row rendered`,props.index);
    const [component, setComponent] = useState(null);

    const isDisabledCell = (row, columnId) => {
        const disabledCellChecker = props.disabledCellChecker;

        if (disabledCellChecker)
            if (disabledCellChecker(row, columnId))
                return true;
        return false;
    }

    useEffect(() => {
        return () => {
            if (props.index === props.focusedCell.coords.x && props.focusedCell.active && component) {
                const row = document.getElementById(`Row-${props.index}`);
                if (!row) return;
                const tableBodyRect = row.parentElement.parentElement.parentElement.getBoundingClientRect();
                const rowRect = row.getBoundingClientRect();
                if ((rowRect.top + rowRect.height) < tableBodyRect.top)
                    props.setCellDirectly(props.focusedCell.coords.x, props.focusedCell.coords.y, false);
            }
        };
    })

    useEffect(() => {
        const timer = setTimeout(() => {
            let row = props.rows[props.index];
            let trClasses = [cssClasses.row];
            if (props.index % 2 !== 0) trClasses.push(cssClasses.odd)
            setComponent(<div className={trClasses.join(' ')} data-row-key={props.getRowKey(row)} data-x={props.index} id={'Row-' + props.index} key={'Row-' + props.index} style={props.style}>
                {props.columns.map((column, y) => {
                    return <Cell
                        y={y}
                        column={column}
                        row={row}
                        rowsCount={props.rows.length}
                        columnsCount={props.columns.length}
                        height={props.height}
                        rowheight={props.rowheight}
                        columnWidthList={props.columnWidthList}
                        focusedCell={props.focusedCell}
                        setCellDirectly={props.setCellDirectly}
                        resizingColumn={props.resizingColumn}
                        index={props.index}
                        key={`X-${props.index}_Y-${y}`}
                        disabled={isDisabledCell(row, column.id)}
                        rowUpdated={props.rowUpdated}
                    ></Cell>
                })}
            </div>)
        });
        return () => clearTimeout(timer);
    }, [props.rows, props.columns, props.focusedCell]);
    let renderedRow = props.loadingRow;
    if (component) renderedRow = <ContextMenuTrigger id={props.contextMenuId} row={props.rows[props.index]} collect={collect}>{component}</ContextMenuTrigger>;
    return renderedRow;
}

export default React.memo(Row, areEqual);



// WEBPACK FOOTER //
// ./src/components/DataTable/Body/Row/row.js